import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';

import { hamburger } from './modules/header/hamburger';
import { header } from './modules/header/header';
import { pageTop } from './modules/common/pageTop';
import { mega } from './modules/header/mega';

const scrollTop = new SmoothScroll('a[href*="#"]', {
  speed: 600,
});

hamburger();
header();
mega();
// pageTop();

const indexHeading = document.querySelector('.p-indexKv_heading');

window.addEventListener('load', () => {
  indexHeading.classList.add('is-view');
});
